import { render, staticRenderFns } from "./laptopView.vue?vue&type=template&id=55f13816&scoped=true&"
import script from "./laptopView.vue?vue&type=script&lang=js&"
export * from "./laptopView.vue?vue&type=script&lang=js&"
import style0 from "./laptopView.vue?vue&type=style&index=0&id=55f13816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f13816",
  null
  
)

export default component.exports